export default {
  disabled: false
};


//////////////////
// WEBPACK FOOTER
// ./~/react-alert/~/react-transition-group/esm/config.js
// module id = 579
// module chunks = 0